// const cartCount = document.querySelector('[data-cart-count-indicator]');

// if (cartCount) {
//   let previousCount = parseInt(cartCount.textContent, 10) || 0;

//   const observer = new MutationObserver(() => {
//     const newCount = parseInt(cartCount.textContent, 10) || 0;

//     if (newCount > previousCount) {
//       observer.disconnect();
//       window.location.href = '/checkout';
//     }

//     previousCount = newCount;
//   });

//   observer.observe(cartCount, { childList: true, characterData: true, subtree: true });
// }
let previousCount = null;
let checkInterval = setInterval(() => {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const newCount = cart.item_count;

            if (previousCount === null) {
                previousCount = newCount; 
                return;
            }

            if (newCount > previousCount) {
                clearInterval(checkInterval);
                window.location.href = '/checkout';
            }

            previousCount = newCount;
        })
        .catch(err => console.error(err));
}, 300); 